import { gql } from 'graphql-request'

export const CHECK_IS_FOLLOWED_PEN_NAME = gql`
  query CheckIsFollowedPenName($penNameId: Int!) {
    checkIsFollowedPenName(penNameId: $penNameId)
  }
`
